import { useTranslate } from '@ur-solutions/react-hooks'
import { ExportTimesheetsCard } from '../components'
import { ExportSection } from '../components/ExportsSettings/components'

export function ExportTimesheets() {
  const translations = useTranslate({
    timesheets: 'common.timesheets',
  })

  return (
    <ExportSection header={translations.timesheets}>
      <ExportTimesheetsCard />
    </ExportSection>
  )
}
